export class config {
 static capiURL = 'https://staging.endpoint.demander-un-devis.capiassur.fr/api'
}